import { ArrowRight } from 'lucide-react';

import { PrimaryCTA } from '../../components/PrimaryCTA';
import { SecondaryCTA } from '../../components/SecondaryCTA';
import { SectionWrapper } from '../../components/SectionWrapper';

import styles from './KaiCoachClosingSection.module.css';

export function KaiCoachClosingSection() {
  return (
    <SectionWrapper
      aria-labelledby="kai-coach-closing-title"
      background="white"
      className={styles.root}
      data-testid="kai-coach-section-closing"
    >
      <div className={styles.card}>
        <p className={styles.kicker}>Start with one course</p>
        <h2 className={styles.title} id="kai-coach-closing-title">
          Bring Kai Coach to your course, <em>or your campus.</em>
        </h2>
        <p className={styles.lead}>
          Kudu builds the module at no cost to your institution. Your part is a mapping call and
          about one to two hours of review.
        </p>
        <div className={styles.actions}>
          <PrimaryCTA
            className={styles.primary}
            href="/contact"
            icon={<ArrowRight aria-hidden="true" size={16} />}
            label="Book a mapping call"
          />
          <SecondaryCTA className={styles.secondary} href="/contact" label="Request the pilot report" />
        </div>
      </div>

      <div className={styles.footnotes}>
        <p className={styles.footnote}>
          Course transcripts are paraphrased. The Physics exchange is a design target, not a
          recorded session.
        </p>
        <p className={styles.footnote}>
          Results: History 2C, UCLA, 2025 (76 students, no coach) and 2026 (56 students, Kai
          Coach), measured from submitted writing. See{' '}
          <a className={styles.footnoteLink} href="#method">
            How to read these results
          </a>
          .
        </p>
        <p className={styles.footnote}>
          Kai Coach was designed and built by Elizabeth Landers, Chief AI Architect, Kudu
          Humanities.
        </p>
      </div>
    </SectionWrapper>
  );
}
